module.exports = __webpack_public_path__ + "static/media/rulesTwo.450c004f.webp";